import * as React from 'react';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { KonkurrenceOverblik } from '../../models/KonkurrenceOverblik';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import KonkurrenceOverblikPresenter from './konkurrenceOverblik/KonkurrenceOverblikPresenter';
import { Jumbotron } from '../../uiComponents/Jumbotron';
import { Bruger } from '../../models/Bruger';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { Spinner } from '../../uiComponents/Spinner';

export interface SkrivebordElevProps {
}

export interface SkrivebordElevState {
    konkurrence?: KonkurrenceOverblik;
    bruger: Bruger;
}

export default class SkrivebordElev extends React.Component<SkrivebordElevProps, SkrivebordElevState> {

    constructor(props: SkrivebordElevProps) {
        super(props);

        this.state = {
            konkurrence: undefined,
            bruger: new Bruger()
        };
    }

    componentDidMount() {
        const apiCaller = createApiCaller();

        apiCaller.getKommendeKonkurrenceOverblik().then(response =>
            this.setState({ konkurrence: response })
        );

        this.setState({
            bruger: getLoggedInBruger()
        });
    }

    renderContent() {
        let content = (<div />);
        let konkurrence = this.state.konkurrence;

        if (this.state.konkurrence === undefined) {
            return <Spinner />;
        } else {
            if (konkurrence !== undefined && konkurrence.harKonkurrence) {
                content = (
                    <div>
                        <KonkurrenceOverblikPresenter
                            konkurrencetitel={konkurrence.konkurrenceTitel}
                            konkurrenceDate={konkurrence.konkurrenceDate}
                            konkurrenceId={konkurrence.konkurrenceId}
                            billedId={konkurrence.billedId}
                            hold={konkurrence.hold[0]}
                            beskrivelse={konkurrence.beskrivelse}
                            showSamletPlacering={konkurrence.showSamletPlacering}
                        />
                    </div>
                );

            } else {
                let brugernavn = this.state.bruger.navn ? this.state.bruger.navn : this.state.bruger.brugernavn;
                let title = `Hej ${brugernavn}, du er desværre ikke tilmeldt nogen nye konkurrencer`;

                content = (
                    <div>
                        <Jumbotron
                            title={title}
                            message='Har du skrevet den rigtige klasse under profil?'
                            icon='warning'
                        />
                    </div>
                );
            }
        }

        return content;
    }

    render() {

        return (
            <div>
                <PageWrapper>
                    <PageTitle title='Skrivebord' />
                    <ContentWrapper>
                        {this.renderContent()}
                    </ContentWrapper>
                </PageWrapper>

            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/SkrivebordElev.tsx